import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { AuthService } from '@app/service/auth.service';

import { SBoardService } from '@shop/service/board.service';

import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';

import { SEstimateComponent } from '@shop/page/member/mypage/estimate-list/estimate/estimate.component';

const options: NgbModalOptions = {
  backdrop: 'static',
  keyboard: false,
  size: 'lg',
  centered: true,
  windowClass:'modal-fadeInDown'
};

@Component({
  selector: 'app-estimate-list',
  templateUrl: './estimate-list.component.html',
  styleUrls: ['./estimate-list.component.scss']
})
export class SEstimateListComponent implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  public boardInfo: any = {};
  public memberInfo: any = {};
  public boardData: any = {};

  public params: any = {
    type: 'list',
    board_id: 'qna',
    group_id: '전체',
    row: 10,
    no: 1,
    group: 'subject',
    text: ''
  };

  public linecnt: any = [];
  public groupTab: any = [];

  public boardList = [];

  public totalCount: number;

  /*******************************************************************************
    설  명 : 생성자
  *******************************************************************************/
  constructor(
    private toastrService: ToastrService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private sBoardService: SBoardService,
    private authService: AuthService,
    private modalService: NgbModal,
    private domSanitizer: DomSanitizer
  ) { }

  /*******************************************************************************
    설  명 : 데이터 초기화
  *******************************************************************************/
  ngOnInit() {
    this.getBoardViewIndex();

    this.authService.getLoginData.subscribe(data => {
      this.memberInfo = data;
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.params.board_id = ( typeof params.board_id == 'undefined' || params.board_id == '' ) ? 'estimate' : params.board_id;
      this.params.group_id = ( typeof params.group_id == 'undefined' || params.group_id == '' ) ? '전체' : params.group_id;
      this.params.type = ( typeof params.type == 'undefined' || params.type == '' ) ? '' : params.type;
      this.params.row = ( typeof params.row == 'undefined' || params.row == '' ) ? 10 : parseInt(params.row);
      this.params.no = ( typeof params.no == 'undefined' || params.no == '' ) ? 1 : parseInt(params.no);
      this.params.group = ( typeof params.group == 'undefined' || params.group == '') ? 'subject' : params.group;
      this.params.text = ( typeof params.text == 'undefined' ) ? '' : params.text;

      this.getBoardInfo( this.params.board_id );
    });
  }

  /*******************************************************************************
    설  명 : 게시판 정보 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  async getBoardInfo( board_id ) {
    await this.sBoardService.getBoardInfoId( board_id ).then( response => {
      if( response.data == null ) {
        this.toastrService.error( "존재하지 않는 게시판입니다.", "" );

        this.router.navigate( ['/main'] );
        return false;
      }

      this.boardInfo = response.data;

      if( this.params.type == '' ) {
        switch( this.boardInfo.lvt_default ) {
          case 'A': this.params.type = 'album'; break;
          case 'G': this.params.type = 'gallery'; break;
          case 'C': this.params.type = 'calendar'; break;
          default: case 'L': this.params.type = 'list';
        }
      }

      if( this.params.type == 'list' ) this.linecnt = this.boardInfo.linecnt_list.split('/');
      else if( this.params.type == 'album' ) this.linecnt = this.boardInfo.linecnt_album.split('/');
      else if( this.params.type == 'gallery' ) this.linecnt = this.boardInfo.linecnt_gallery.split('/');

      if( this.boardInfo.lvt_group == '1' ) {
        this.boardInfo.group = '전체|' + this.boardInfo.group;
        this.groupTab = this.boardInfo.group.split('|');
      }

      this.getBoardList();
    });
  }

  /*******************************************************************************
    설  명 : 게시판 리스트 정보 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getBoardList() {
    this.sBoardService.getEstimateList( this.params ).then( response => {
      this.boardList = response.data;
      this.boardInfo.total_count = response.total;

      this.totalCount = parseInt( response.total );

      this.deleteParams();
    });
  }

  /*******************************************************************************
    설  명 : 게시글 정보 가져오기
    입력값 : 게시판 아이디, 게시판 코드
    리턴값 : 없음
  *******************************************************************************/
  getBoardViewIndex() {
    this.sBoardService.getBoardViewIndex( 'contents', '1000000050000000000' ).then( response => {
      if( response.ResultCode ) {
        this.boardData = response.data;
      } else {
        this.toastrService.error( response.ResultMessage, '견적서 확인 안내' );
      }
    });
  }

  /*******************************************************************************
    설  명 : restful get, post params 삭제
  *******************************************************************************/
  deleteParams() {
    delete this.params.program;
    delete this.params.service;
    delete this.params.version;
    delete this.params.action;
    delete this.params.token;
  }

  /*******************************************************************************
    설  명 : 게시판 리스트 타입 변경
    입력값 : type = L, A, C, G
    리턴값 : 없음
  *******************************************************************************/
  viewChange( type ) {
    this.params.type = type;

    this.router.navigate(
    ['/mypage/estimate/view'],
    {
      relativeTo: this.activatedRoute,
      queryParams: this.params,
      queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

  /*******************************************************************************
    설  명 : 글 쓰기 권한
    입력값 : 없음
    리턴값 : true / false
  *******************************************************************************/
  authWriteCheck(): boolean {
    if( this.boardInfo.auth_write <= this.memberInfo.level ) {
      return true;
    } else {
      return false;
    }
  }

  /*******************************************************************************
    설  명 : 페이지 선택 처리
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  loadPage( page ) {
    this.params.no = page;

    this.router.navigate(
    ['/mypage/estimate'],
    {
      relativeTo: this.activatedRoute,
      queryParams: this.params,
      queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

  /*******************************************************************************
    설  명 : 페이지 리스트 새로고침
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  loadList( group_id ) {
    this.params.group_id = group_id;

    this.router.navigate(
    ['/mypage/estimate'],
    {
      relativeTo: this.activatedRoute,
      queryParams: this.params,
      queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

  /*******************************************************************************
    설  명 : 삭제 가능 여부 확인
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  authCheck( row: any ) {
    // 관리자 권한일 경우 삭제 가능
    if( this.memberInfo.level >= 80 ) {
      return true;
    }

    // 작성자의 경우
    if( this.memberInfo.mem_no == row.writer ) return true;

    return false;
  }

  /*******************************************************************************
    설  명 : 상세보기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  view( row: any ) {
    this.params.board_seq = row.board_seq;

    this.router.navigate(
    ['/mypage/estimate/view'],
    {
      relativeTo: this.activatedRoute,
      queryParams: this.params,
      queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

  /*******************************************************************************
    설  명 : 게시글 등록
  *******************************************************************************/
  write() {
    /*
    const modalRef = this.modalService.open(SEstimateComponent, options);

    modalRef.componentInstance.boardId = this.params.board_id;

    modalRef.result.then((result) => {
      this.getBoardList();
    }, (reason) => {
    });
    */
   this.router.navigate(
    ['/mypage/estimate/request'],
    {
      relativeTo: this.activatedRoute,
      queryParams: {},
      queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

  /*******************************************************************************
    설  명 : 게시글 수정
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  modify( row: any ) {
    /*
    const modalRef = this.modalService.open(SEstimateComponent, options);

    modalRef.componentInstance.boardId = this.params.board_id;
    modalRef.componentInstance.rowData = row;

    modalRef.result.then((result) => {
      this.getBoardList();
    }, (reason) => {
    });
    */
   this.router.navigate(
    ['/mypage/estimate/request'],
    {
      relativeTo: this.activatedRoute,
      queryParams: {boardSeq: row.board_seq},
      queryParamsHandling: '', // remove to replace all query params by provided
    });
  }

  /*******************************************************************************
    설  명 : 게시글 삭제
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  delete( row: any ) {
    if( confirm("게시글을 삭제하시겠습니까?") ) {
      this.sBoardService.deleteBoard( this.boardInfo.board_id, row.board_seq ).then( response => {
        if( response.ResultCode ) {
          this.toastrService.success( response.ResultMessage, '' );

          this.router.navigate(
          ['/mypage/estimate'],
          {
            relativeTo: this.activatedRoute,
            queryParams: this.params,
            queryParamsHandling: '', // remove to replace all query params by provided
          });

        } else {
          this.toastrService.error( response.ResultMessage, '' );
        }
      });
    }
  }

  /*******************************************************************************
    설  명 : 주문가이드 텍스트 처리
    입력값 : 없음
    리턴값 : SafeHtml
  *******************************************************************************/
  getSafeHtml( html: any ): SafeHtml {
    return this.domSanitizer.bypassSecurityTrustHtml(html);
  }

}